export const support = {
  title: "Soporte",
  subtitle: "Obtené ayuda de nuestro equipo de soporte",
  tickets: {
    title: "Tickets",
    create: "Crear Ticket",
    createFree: "Solo para clientes pagos",
    status: {
      OPEN: "Abierto",
      IN_PROGRESS: "En Progreso",
      RESOLVED: "Resuelto",
      CLOSED: "Cerrado",
    },
    priority: {
      LOW: "Baja",
      MEDIUM: "Media",
      HIGH: "Alta",
      URGENT: "Urgente",
    },
    table: {
      title: "Título",
      status: "Estado", // More common than "Status"
      client: "Cliente",
      priority: "Prioridad",
      createdAt: "Creado el", // More natural than "Criado em"
      lastUpdate: "Última actualización",
      actions: "Acciones",
    },
    actions: {
      view: "Ver", // "Ver" is more concise than "Visualizar"
      reply: "Responder",
      close: "Cerrar",
      changePriority: "Cambiar Prioridad",
    },
    modal: {
      title: "Nuevo Ticket",
      titleLabel: "Describí brevemente tu problema o pregunta",
      titlePlaceholder: "Describí brevemente tu problema o pregunta",
      descriptionLabel: "Describí tu problema o pregunta en detalle",
      descriptionPlaceholder: "Describí tu problema o pregunta en detalle",
      priorityLabel: "Prioridad",
      priority: {
        low: "Baja",
        medium: "Media",
        high: "Alta",
        urgent: "Urgente",
      },
      submit: "Enviar",
    },
  },
  detail: {
    description: "Descripción",
    conversation: "Conversación",
    created: "Creado el {{date}}",
    replyPlaceholder: "Escribí tu respuesta aquí",
    user: "Vos", // Using "vos"
    staff: "Equipo",
    send: "Enviar",
    success: {
      messageSent: "Mensaje enviado correctamente",
    },
    error: {
      loading: "Error al cargar el ticket",
      sending: "Error al enviar el mensaje",
    },
  },
};
